import { Component, EventEmitter, Input, Output } from '@angular/core';
import { normalizeProjectTitle, PROJECT_TITLE_MAX_LENGTH } from 'src/app/services/helpers/project-title.helper';

/**
 * Titre d'un projet, modifiable en ligne.
 * Émet le titre saisi après normalisation par {@link normalizeProjectTitle}.
 */
@Component({
  selector: 'ng-casto-project-title',
  templateUrl: './project-title.component.html',
  styleUrl: './project-title.component.scss',
})
export class ProjectTitleComponent {
  /** Titre affiché. */
  @Input() title: string;

  /** Interdit la modification du titre. */
  @Input() disabled = false;

  /** Titre saisi, émis uniquement s'il diffère du titre affiché. */
  @Output() titleChange = new EventEmitter<string>();

  /** Longueur maximale de la saisie. */
  readonly maxLength = PROJECT_TITLE_MAX_LENGTH;

  /** Indique si la saisie est ouverte. */
  isEditing = false;

  /** Valeur en cours de saisie. */
  draft = '';

  /** Ouvre la saisie, pré-remplie avec le titre affiché. */
  startEditing(): void {
    this.draft = this.title;
    this.isEditing = true;
  }

  /** Ferme la saisie et émet le titre normalisé s'il a changé. */
  save(): void {
    this.isEditing = false;

    const title = normalizeProjectTitle(this.draft);
    if (title === this.title) {
      return;
    }

    this.titleChange.emit(title);
  }
}
